var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoColorSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5239_12531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.221 13.2586C13.6185 12.391 14.8326 12.391 15.2301 13.2586L17.9902 19.2821C18.3322 20.0285 17.796 20.8833 16.9857 20.8833H11.4655C10.6552 20.8833 10.1189 20.0285 10.4609 19.2821L13.221 13.2586Z",
    fill: "#6B40ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.161806 7.19671C-0.301258 5.32523 1.06487 3.69216 2.88953 3.54913L25.3329 1.78986C27.1575 1.64683 28.7498 3.04801 28.8892 4.91949C29.0287 6.79096 27.6625 8.42403 25.8379 8.56706L3.39453 10.3263C1.56987 10.4694 -0.0223544 9.06818 -0.161806 7.19671Z",
    fill: "#2F84EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5239_12531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorSmall);
export default __webpack_public_path__ + "static/media/logo-color-small.5a82f1cc24a64665fe7276743ba8931e.svg";
export { ForwardRef as ReactComponent };